module.exports = __webpack_public_path__ + "static/media/info_icon_squared.011b58e9.svg";